import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { KeyboardEvent, ReactNode, Ref } from 'react';
import { ONBOARDING_PANEL_ID } from '../../constants';
type OnboardingTabProps = {
  id: string;
  isSelected: boolean;
  onClick: () => void;
  onKeyDown: (event: KeyboardEvent<HTMLButtonElement>) => void;
  ref: Ref<HTMLButtonElement>;
  children: ReactNode;
};
const OnboardingTab = t0 => {
  const $ = _c(12);
  const {
    id,
    isSelected,
    onClick,
    onKeyDown,
    ref,
    children
  } = t0;
  const t1 = isSelected ? 0 : -1;
  const t2 = !isSelected;
  let t3;
  if ($[0] !== isSelected || $[1] !== t2) {
    t3 = cx("w-60 shrink-0 bg-primary p-3 border border-solid rounded cursor-pointer transition-colors duration-100 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-primary", {
      "border-tertiary hover:border-primary": t2,
      "border-accent shadow-sm": isSelected
    });
    $[0] = isSelected;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== id || $[5] !== isSelected || $[6] !== onClick || $[7] !== onKeyDown || $[8] !== ref || $[9] !== t1 || $[10] !== t3) {
    t4 = <button ref={ref} id={id} type="button" role="tab" aria-selected={isSelected} aria-controls={ONBOARDING_PANEL_ID} tabIndex={t1} className={t3} onClick={onClick} onKeyDown={onKeyDown}>{children}</button>;
    $[3] = children;
    $[4] = id;
    $[5] = isSelected;
    $[6] = onClick;
    $[7] = onKeyDown;
    $[8] = ref;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default OnboardingTab;